import { bool, object, string } from 'yup';

export const EmailBaseSchema = object().shape({
  template: string().required(),
  // If the CS team was notified in slack
  notifiedFailure: bool(),
});
